import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import Add from "@material-ui/icons/Add";
import get from "lodash/get";
import Helmet from "react-helmet";
import headersList from "Constants/headersList";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import { CheckActionPermission } from "Actions/commonAction";
import DynamicForm from "Component/DynamicForm";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
import { instance } from "../../../../../../Actions/AxiosInstance";
import CheckImg from "../../../../../../Assets/Images/aaa.png";
import warning from "../../../../../../Assets/Images/warning.svg";
import deleteIcon from "../../../../../../Assets/newicons/action/delete-bin/outline/delete-bin-outline-16px.svg";
import { formatArrayOrSplitString } from "../../../../../../Utils";

function getAccess(access) {
  if (access) {
    const checkLocObject = access.find(
      (access1) => access1.applicablefortypeid == 3,
    );
    if (!checkLocObject) {
      const object = access[0];
      const locationObj = {
        compensatoraccessid: 0,
        applicablefortypeid: 3,
        applicableforids: formatArrayOrSplitString(
          object && object.locationids && object.locationids,
        ),
        locationids: null,
      };
      const allAccess = access.map((x) => ({
        ...x,
        locationids: null,
      }));
      allAccess.push(locationObj);
      return allAccess;
    }
    return access;
  }
  return [];
}

let globalcomps = [];
class Compensator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ischecked: false,
      empList: [],
      SelectedEmpData: null,
      BusinessUnitList: [],
      DepartmentList: [],
      LocationList: [],
      expensecompensatorid: null,
      applicablefortypeid: "",
      locationids: [],
      compensatorList: [],
      selectedBusinessUnit: null,
      dropdown: false,
      selectedCompensator: null,
      allbu: false,
      alldep: false,
      allloc: false,
    };
    this.setischecked = this.setischecked.bind(this);
    this.SearchEmployee = this.SearchEmployee.bind(this);
    this.GetBusinessUnitList = this.GetBusinessUnitList.bind(this);
    this.GetDepartmentList = this.GetDepartmentList.bind(this);
    this.GetLocationList = this.GetLocationList.bind(this);
    this.GetCompensatorData = this.GetCompensatorData.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.UpdateSelectedEmpId = this.UpdateSelectedEmpId.bind(this);
    this.setCompensator = this.setCompensator.bind(this);
    this.updateCompensatorList = this.updateCompensatorList.bind(this);
    this.addCompensator = this.addCompensator.bind(this);
    this.selectAll = this.selectAll.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
  }

  setischecked() {
    this.setState({ ischecked: !this.state.ischecked });
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("compensator");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.GetBusinessUnitList();
        this.GetDepartmentList();
        this.GetLocationList();
        this.GetCompensatorData();
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  SearchEmployee(search) {
    if (search.length < 1) return;
    if (
      (!this.state.prevSearch || this.state.prevSearch != search) &&
      search.length >= 1
    ) {
      const URL = `/subscription/employeelist`;
      const data = {
        searchfor: search,
        statusid: 1,
      };
      instance
        .post(URL, data)
        .then((result) => {
          this.setState({ empList: result.data.result });
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  GetBusinessUnitList() {
    instance
      .get("subscription/allbusinessunitlist")
      .then((result) => {
        let BusinessUnitList = [];
        if (result.data.result.length > 0) {
          BusinessUnitList = result.data.result;
        }
        this.setState({ BusinessUnitList });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetDepartmentList() {
    instance
      .get("subscription/alldepartmentlist")
      .then((result) => {
        let DepartmentList = [];
        if (result.data.result.length > 0) {
          DepartmentList = result.data.result;
        }
        this.setState({ DepartmentList });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetLocationList() {
    const data = {
      featurekey: "directory",
      subscriptionid: get(this.props, "SubscriptionData.subscriptionid", ""),
    };
    instance
      .post(`subscription/allcompanylocation`, data)
      .then((result) => {
        let LocationList = [];
        if (result.data.result.length > 0) {
          LocationList = result.data.result;
        }
        this.setState({ LocationList });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetCompensatorData() {
    instance
      .get("expense/compensator")
      .then((result) => {
        let compensatorList = result.data.result.map((x) => ({
          ...x,
          access:
            (x.access &&
              x.access.map((y) => ({
                ...y,
                applicableforids: formatArrayOrSplitString(y.applicableforids),
              }))) ||
            [],
        }));

        compensatorList = compensatorList.map((x) => ({
          ...x,
          access: getAccess(x.access) || [],
        }));

        if (globalcomps.length > 0) {
          compensatorList = [...compensatorList, ...globalcomps];
        }
        this.setState({
          compensatorList,
          compensatorList2: [
            ...compensatorList.filter((comp) => comp.expensecompensatorid != 0),
          ],
          dropdown: !(result.data.result.length > 0),
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  addCompensator() {
    this.setState({
      dropdown: true,
      selectedCompensator: null,
      SelectedEmpData: null,
      allbu: false,
      alldep: false,
      allloc: false,
    });
  }

  setCompensator(selectedCompensator) {
    this.setState({
      selectedCompensator,
      dropdown: false,
      allbu: false,
      alldep: false,
      allloc: false,
    });
  }

  UpdateSelectedEmpId(selectedItem) {
    if (selectedItem && selectedItem.displayvalue) {
      const { compensatorList } = this.state;
      const obj = this.state.compensatorList.find(
        (comp) => comp.compensatorempid == selectedItem.displayvalue,
      );
      if (!obj) {
        compensatorList.push({
          compensatorempid: selectedItem.displayvalue,
          fullname: selectedItem.displayname,
          expensecompensatorid: 0,
          access: [],
        });
        if (selectedItem) {
          this.setState(
            {
              dropdown: false,
              SelectedEmpData: selectedItem,
              selectedCompensator: {
                expensecompensatorid: 0,
                access: [],
                compensatorempid: selectedItem.displayvalue,
                fullname: selectedItem.displayname,
              },
              compensatorList,
            },
            () => {},
          );
        }
      } else {
        this.setState({
          dropdown: false,
        });
      }
    }
  }

  selectAll(applicablefortypeid, flag) {
    const { selectedCompensator } = this.state;
    console.log("selectedCompensator: ", selectedCompensator);
    const { compensatorList } = this.state;
    console.log("compensatorList: ", compensatorList);
    if (selectedCompensator) {
      let selectedAccess = selectedCompensator.access.find(
        (access) => access.applicablefortypeid == applicablefortypeid,
      );
      const selectedAccessIndex = selectedCompensator.access.findIndex(
        (access) => access.applicablefortypeid == applicablefortypeid,
      );
      if (selectedCompensator.access && selectedCompensator.access.length > 0) {
        if (flag) {
          const object = {
            compensatoraccessid:
              selectedAccess && selectedAccess.compensatoraccessid
                ? selectedAccess.compensatoraccessid
                : 0,
            applicablefortypeid,
            applicableforids:
              applicablefortypeid == 1
                ? this.state.BusinessUnitList.map(
                    (business) => business.businessunitid,
                  )
                : applicablefortypeid == 2
                ? this.state.DepartmentList.map(
                    (business) => business.departmentid,
                  )
                : this.state.LocationList.map(
                    (business) => business.displayvalue,
                  ),
            locationids: null,
          };
          selectedAccess = object;
        } else {
          const object = {
            compensatoraccessid:
              selectedAccess && selectedAccess.compensatoraccessid
                ? selectedAccess.compensatoraccessid
                : 0,
            applicablefortypeid,
            applicableforids: null,
            locationids: null,
          };
          selectedAccess = object;
        }

        if (selectedAccessIndex != -1) {
          selectedCompensator.access[selectedAccessIndex] = selectedAccess;
        } else {
          selectedCompensator.access.push(selectedAccess);
        }
      } else if (flag) {
        let object = {};
        if (selectedAccess) {
          const x = {
            compensatoraccessid: selectedAccess.compensatoraccessid,
            applicablefortypeid,
            applicableforids:
              applicablefortypeid == 1
                ? this.state.BusinessUnitList.map(
                    (business) => business.businessunitid,
                  )
                : applicablefortypeid == 2
                ? this.state.DepartmentList.map(
                    (business) => business.departmentid,
                  )
                : this.state.LocationList.map(
                    (business) => business.displayvalue,
                  ),
            locationids: null,
          };
          object = x;
        } else {
          const y = {
            compensatoraccessid: 0,
            applicablefortypeid,
            applicableforids:
              applicablefortypeid == 1
                ? this.state.BusinessUnitList.map(
                    (business) => business.businessunitid,
                  )
                : applicablefortypeid == 2
                ? this.state.DepartmentList.map(
                    (business) => business.departmentid,
                  )
                : this.state.LocationList.map(
                    (business) => business.displayvalue,
                  ),
            locationids: null,
          };
          object = y;
        }
        const x = [];
        x.push(object);
        selectedCompensator.access = x;
        selectedAccess = object;
      } else if (!flag) {
        let object = {};
        if (selectedAccess) {
          object = {
            compensatoraccessid: selectedAccess.compensatoraccessid,
            applicablefortypeid,
            applicableforids: null,
            locationids: null,
          };
        } else {
          object = {
            compensatoraccessid: 0,
            applicablefortypeid,
            applicableforids: null,
            locationids: null,
          };
        }
        const x = [];
        x.push(object);
        selectedAccess = object;
        selectedCompensator.access = x;
      }
      const compIndex = compensatorList.findIndex(
        (comp) => comp.compensatorempid == selectedCompensator.compensatorempid,
      );

      if (compIndex != -1) {
        compensatorList[compIndex] = selectedCompensator;
      }
      this.setState({
        selectedCompensator,
        compensatorList,
        allbu: applicablefortypeid == 1 ? flag : this.state.allbu,
        alldep: applicablefortypeid == 2 ? flag : this.state.alldep,
        allloc: applicablefortypeid == 3 ? flag : this.state.allloc,
      });
    }
  }

  updateCompensatorList(applicablefortypeid, applicableforid, flag) {
    if (this.state.selectedCompensator) {
      let object = {};
      const { compensatorList } = this.state;
      const { selectedCompensator } = this.state;
      const selectedAccess = selectedCompensator.access.find(
        (access) => access.applicablefortypeid == applicablefortypeid,
      );
      const selectedAccessIndex = selectedCompensator.access.findIndex(
        (access) => access.applicablefortypeid == applicablefortypeid,
      );

      if (selectedAccess && selectedAccessIndex != -1) {
        let x = [];
        if (!selectedAccess.applicableforids) {
          if (flag) {
            object = {
              compensatoraccessid:
                selectedAccess && selectedAccess.compensatoraccessid
                  ? selectedAccess.compensatoraccessid
                  : 0,
              applicablefortypeid,
              applicableforids: [applicableforid],
              locationids: null,
            };
          } else {
            object = {
              compensatoraccessid:
                selectedAccess && selectedAccess.compensatoraccessid
                  ? selectedAccess.compensatoraccessid
                  : 0,
              applicablefortypeid,
              applicableforids: null,
              locationids: null,
            };
          }
        } else if (selectedAccess.applicableforids) {
          if (flag) {
            x = [...selectedAccess.applicableforids, applicableforid];
            object = {
              compensatoraccessid:
                selectedAccess && selectedAccess.compensatoraccessid
                  ? selectedAccess.compensatoraccessid
                  : 0,
              applicablefortypeid,
              applicableforids: Array.from(new Set(x)),
              locationids: null,
            };
          } else {
            // x = [...selectedAccess.applicableforids, applicableforid];
            const appIndex = selectedAccess.applicableforids.findIndex(
              (app) => app == applicableforid,
            );
            selectedAccess.applicableforids.splice(appIndex, 1);
            if (selectedAccess.applicableforids.length > 0) {
              object = {
                compensatoraccessid:
                  selectedAccess && selectedAccess.compensatoraccessid
                    ? selectedAccess.compensatoraccessid
                    : 0,
                applicablefortypeid,
                applicableforids: Array.from(
                  new Set(selectedAccess.applicableforids),
                ),
                locationids: null,
              };
            } else {
              object = {
                compensatoraccessid:
                  selectedAccess && selectedAccess.compensatoraccessid
                    ? selectedAccess.compensatoraccessid
                    : 0,
                applicablefortypeid,
                applicableforids: null,
                locationids: null,
              };
            }
          }
        }
        if (selectedAccessIndex != -1) {
          selectedCompensator.access[selectedAccessIndex] = object;
        }
      } else {
        object = {
          compensatoraccessid:
            selectedAccess && selectedAccess.compensatoraccessid
              ? selectedAccess.compensatoraccessid
              : 0,
          applicablefortypeid,
          applicableforids: [applicableforid],
          locationids: null,
        };
        const { access } = selectedCompensator;
        access.push(object);
        selectedCompensator.access = access;
      }
      const compIndex = compensatorList.findIndex(
        (comp) => comp.compensatorempid == selectedCompensator.compensatorempid,
      );

      if (compIndex != -1) {
        compensatorList[compIndex] = selectedCompensator;
      }
      this.setState({ selectedCompensator, compensatorList });
    }
  }

  onSave() {
    function modifiedAccess(access = []) {
      let result = access;
      const locationObj = access.find((x) => x.applicablefortypeid == 3);
      if (locationObj && access.length != 1) {
        // add 'locationids' into buunit and dept
        result = result.map((x) => ({
          ...x,
          locationids: locationObj.applicableforids || null,
        }));
        // remove 'locationObj'
        result = result.filter((x) => x.applicablefortypeid != 3);
      } else if (locationObj && access.length == 1) {
        result = result.map((x) => ({
          ...x,
          locationids: x.applicableforids || null,
        }));
      }
      return result;
    }

    function changeAccess(access = []) {
      const result = access;
      const locationObj = access.find((x) => x.applicablefortypeid == 3);
      const depObj = access.find((x) => x.applicablefortypeid == 2);
      const buObj = access.find((x) => x.applicablefortypeid == 1);
      const location = access.findIndex((x) => x.applicablefortypeid == 3);
      const dep = access.findIndex((x) => x.applicablefortypeid == 2);
      const bu = access.findIndex((x) => x.applicablefortypeid == 1);
      if (locationObj && locationObj.applicableforids == null) {
        result.splice(location, 1);
      }
      if (depObj && depObj.applicableforids == null) {
        result.splice(dep, 1);
      }
      if (buObj && buObj.applicableforids == null) {
        result.splice(bu, 1);
      }
      return result;
    }

    let newCompensatorList = this.state.compensatorList.map((compensator) => ({
      ...compensator,
      access: modifiedAccess(compensator.access),
    }));

    newCompensatorList = newCompensatorList.map((compensator) => ({
      ...compensator,
      access: changeAccess(compensator.access),
    }));

    let flag = false;
    newCompensatorList.forEach((compensator) => {
      if (compensator.access == null || compensator.access.length == 0) {
        flag = true;
        return;
      }
    });

    if (flag) {
      this.props.enqueueSnackbar("Please select at least one access limit", {
        variant: "error",
      });
    } else {
      const data = {
        compensator: newCompensatorList,
      };

      const URL = `expense/compensator`;
      instance
        .post(URL, data)
        .then(() => {
          this.props.enqueueSnackbar("Saved Successfully", {
            variant: "success",
          });
          this.GetCompensatorData();
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  onDelete(id, flag) {
    if (flag) {
      const { compensatorList } = this.state;
      const compensatorList1 = compensatorList;
      const compensatorIndex = compensatorList1.findIndex(
        (compensator) => compensator.compensatorempid == id,
      );
      compensatorList1.splice(compensatorIndex, 1);
      this.setState({
        compensatorList: compensatorList1,
        selectedCompensator: null,
      });
    } else if (!flag) {
      if (this.state.compensatorList2.length > 1) {
        instance
          .delete(`expense/compensator/${id}`)
          .then(() => {
            this.props.enqueueSnackbar(
              "Compensator details deleted successfully",
              { variant: "success" },
            );
            globalcomps = this.state.compensatorList.filter(
              (compensator) => compensator.expensecompensatorid == 0,
            );
            this.GetCompensatorData();
          })
          .catch((error) => {
            const CommonError = error.response
              ? error.response.data.error.message
              : error.message;
            this.props.enqueueSnackbar(CommonError, { variant: "error" });
          });
      } else {
        this.props.enqueueSnackbar("Please save more than 1 compensator", {
          variant: "error",
        });
      }
    }
  }

  confirmDelete(id, flag) {
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          key="1"
          color="inherit"
          size="small"
          onClick={() => {
            this.props.closeSnackbar();
            this.onDelete(id, flag);
          }}
        >
          Yes
        </Button>,
        <Button
          key="2"
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          No
        </Button>,
      ],
    });
  }

  render() {
    const { selectedCompensator } = this.state;

    return (
      <div className="content-outer-wrapper">
        <Helmet>
          <title>{headersList.Config.Compensator.header}</title>
        </Helmet>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <Grid container className="expense-outer">
            <Grid item xs={12} md={12} sm={12}>
              <div>
                <span className="page-header-name">
                  Compensator Configuration
                </span>
                <span className="page-subheader-name">
                  You can assign compensator(s) to process your expenses here
                </span>
              </div>
            </Grid>
            <Grid item xs={12} md={12} sm={12}>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  md={3}
                  sm={3}
                  style={{ position: "relative", left: 1 }}
                >
                  <div>
                    <div>
                      {this.state.compensatorList &&
                        this.state.compensatorList.map(
                          (compensator, compindex) => (
                            <div
                              key={compindex}
                              className={
                                get(
                                  selectedCompensator,
                                  "compensatorempid",
                                  "",
                                ) == compensator.compensatorempid
                                  ? "selected-div1 clear-float"
                                  : "clear-float"
                              }
                              style={{ height: 40 }}
                            >
                              <div
                                className="compensator-name floatleft"
                                onClick={() => this.setCompensator(compensator)}
                              >
                                {compensator.fullname}
                              </div>
                              {this.state.permissions &&
                                this.state.permissions.editable &&
                                this.state.compensatorList.length > 1 && (
                                  <div
                                    className="floatright margin-top-10 margin-right-20 cursor-pointer"
                                    onClick={
                                      compensator.expensecompensatorid == 0
                                        ? () =>
                                            this.confirmDelete(
                                              compensator.compensatorempid,
                                              true,
                                            )
                                        : () =>
                                            this.confirmDelete(
                                              compensator.expensecompensatorid,
                                              false,
                                            )
                                    }
                                  >
                                    <img src={deleteIcon}></img>
                                  </div>
                                )}
                            </div>
                          ),
                        )}
                    </div>

                    {this.state.dropdown && (
                      <div className="selected-div1">
                        <Select
                          className="selectsearch inlindClass width250 padding1"
                          onChange={this.UpdateSelectedEmpId}
                          onInputChange={this.SearchEmployee}
                          options={this.state.empList}
                          getOptionLabel={(option) => option.displayname}
                          getOptionValue={(option) => option.displayvalue}
                          value={this.state.SelectedEmpData}
                          isDisabled={
                            this.state.permissions &&
                            !this.state.permissions.editable
                          }
                          placeholder="Search Employee"
                          isClearable={true}
                        />
                      </div>
                    )}
                    {this.state.permissions && this.state.permissions.editable && (
                      <div
                        className="margin-top-10 cursor-pointer clear-both"
                        onClick={this.addCompensator}
                      >
                        <Add
                          style={{
                            height: 16,
                            width: 16,
                            marginLeft: 8,
                            marginRight: 16,
                            position: "relative",
                            top: 3,
                            borderRadius: 16,
                            background: "#1e8ced",
                            color: "#fff",
                          }}
                        />
                        <span style={{ color: "#1e8ced", fontSize: 14 }}>
                          Add Compensator
                        </span>
                      </div>
                    )}
                  </div>
                </Grid>
                <Grid item xs={12} md={9} sm={9}>
                  <Grid
                    container
                    style={{
                      border: "solid 1px #d9dadb",
                      borderRadius: 4,
                      height: 464,
                    }}
                  >
                    <Grid
                      item
                      md={4}
                      sm={12}
                      className="compensator-assignment-list"
                      style={{
                        borderRight: "solid 1px #d9dadb",
                        overflowY: "auto",
                        height: "calc(100% - 10px)",
                      }}
                    >
                      <div style={{ padding: "0 16px" }}>
                        <div style={{ height: 20 }}>
                          <div className="text-center sub-heading">
                            Select business unit
                          </div>
                        </div>
                        <div className="compensator-checkbox">
                          <div className="margin-bottom-16 margin-top-16 cursurpointer">
                            <span className="all-select">Select all</span>
                            {this.state.allbu ? (
                              <span
                                className="floatright"
                                onClick={() =>
                                  this.state.permissions &&
                                  this.state.permissions.editable &&
                                  this.selectAll(1, false)
                                }
                              >
                                <img src={CheckImg} alt="" height="20" />
                              </span>
                            ) : (
                              <span
                                className="not-selected"
                                onClick={() =>
                                  this.state.permissions &&
                                  this.state.permissions.editable &&
                                  this.selectAll(1, true)
                                }
                              ></span>
                            )}
                            {/* {this.state.allbu ? (
                             <DynamicForm
                             fields={checkboxinputconverter({
                               value: true,
                               placeholder: "",
                               label: "",
                               // disabled: participant[0].isSelected == false ? true : false,
                             })}
                             onChange={() => this.selectAll(1, false)
                             }
                          /> ) : (
                          <DynamicForm
                          fields={checkboxinputconverter({
                            value: false,
                            placeholder: "",
                            label: "",
                            // disabled: participant[0].isSelected == false ? true : false,
                          })}
                          onChange={() => this.selectAll(1, true)
                          }
                        />
                          )} */}
                          </div>
                          {this.state.BusinessUnitList &&
                            this.state.BusinessUnitList.map(
                              (businessunit, buindex) => {
                                const buAccessObject =
                                  get(
                                    this.state,
                                    "selectedCompensator.access",
                                    "",
                                  ) &&
                                  get(
                                    this.state,
                                    "selectedCompensator.access",
                                    [],
                                  ).find((x) => x.applicablefortypeid == 1);
                                let isChecked = false;
                                if (
                                  buAccessObject &&
                                  buAccessObject.applicableforids &&
                                  buAccessObject.applicableforids.length > 0 &&
                                  buAccessObject.applicableforids.findIndex(
                                    (y) => y == businessunit.businessunitid,
                                  ) != -1
                                ) {
                                  isChecked = true;
                                } else {
                                  isChecked = false;
                                }
                                return (
                                  <div
                                    key={buindex}
                                    className="margin-bottom-16 margin-top-16"
                                  >
                                    <span className="select-label ellipsis">
                                      {businessunit.businessunitname}
                                    </span>
                                    {isChecked ? (
                                      <span
                                        className="floatright cursurpointer"
                                        onClick={() =>
                                          this.state.permissions &&
                                          this.state.permissions.editable &&
                                          this.updateCompensatorList(
                                            1,
                                            businessunit.businessunitid,
                                            false,
                                          )
                                        }
                                      >
                                        <img
                                          src={CheckImg}
                                          alt=""
                                          height="20"
                                        />
                                      </span>
                                    ) : (
                                      <span
                                        className="not-selected cursurpointer"
                                        onClick={() =>
                                          this.state.permissions &&
                                          this.state.permissions.editable &&
                                          this.updateCompensatorList(
                                            1,
                                            businessunit.businessunitid,
                                            true,
                                          )
                                        }
                                      />
                                    )}
                                  </div>
                                );
                              },
                            )}
                        </div>
                      </div>
                    </Grid>
                    <Grid
                      item
                      md={4}
                      sm={12}
                      className="compensator-assignment-list"
                      style={{
                        borderRight: "solid 1px #d9dadb",
                        overflowY: "auto",
                        height: "calc(100% - 10px)",
                      }}
                    >
                      <div style={{ padding: "0 16px" }}>
                        <div style={{ height: 20 }}>
                          <div className="text-center sub-heading">
                            Select department
                          </div>
                        </div>
                        <div className="compensator-checkbox">
                          <div className="margin-bottom-16 margin-top-16 cursurpointer">
                            <span className="all-select">Select all</span>
                            {this.state.alldep ? (
                              <span
                                className="floatright"
                                onClick={() =>
                                  this.state.permissions &&
                                  this.state.permissions.editable &&
                                  this.selectAll(2, false)
                                }
                              >
                                <img src={CheckImg} alt="" height="20" />
                              </span>
                            ) : (
                              <span
                                className="not-selected"
                                onClick={() =>
                                  this.state.permissions &&
                                  this.state.permissions.editable &&
                                  this.selectAll(2, true)
                                }
                              ></span>
                            )}
                            {/* {this.state.alldep ? (
                             <DynamicForm
                             fields={checkboxinputconverter({
                               value: true,
                               placeholder: "",
                               label: "",
                               // disabled: participant[0].isSelected == false ? true : false,
                             })}
                             onChange={() => this.selectAll(2, false)
                             }
                          /> ) : (
                          <DynamicForm
                          fields={checkboxinputconverter({
                            value: false,
                            placeholder: "",
                            label: "",
                            // disabled: participant[0].isSelected == false ? true : false,
                          })}
                          onChange={() => this.selectAll(2, true)
                          }
                        />
                          )} */}
                          </div>
                          {this.state.DepartmentList &&
                            this.state.DepartmentList.map(
                              (department, depindex) => {
                                const departmentAccessObject =
                                  get(
                                    this.state,
                                    "selectedCompensator.access",
                                    "",
                                  ) &&
                                  get(
                                    this.state,
                                    "selectedCompensator.access",
                                    [],
                                  ).find((x) => x.applicablefortypeid == 2);
                                let isChecked = false;
                                if (
                                  departmentAccessObject &&
                                  departmentAccessObject.applicableforids &&
                                  departmentAccessObject.applicableforids
                                    .length > 0 &&
                                  departmentAccessObject.applicableforids.findIndex(
                                    (y) => y == department.departmentid,
                                  ) != -1
                                ) {
                                  isChecked = true;
                                } else {
                                  isChecked = false;
                                }
                                return (
                                  <div
                                    key={depindex}
                                    className="margin-bottom-16 margin-top-16 cursurpointer"
                                  >
                                    <span className="select-label ellipsis">
                                      {department.departmentname}
                                    </span>
                                    {isChecked ? (
                                      <span
                                        className="floatright"
                                        onClick={() =>
                                          this.state.permissions &&
                                          this.state.permissions.editable &&
                                          this.updateCompensatorList(
                                            2,
                                            department.departmentid,
                                            false,
                                          )
                                        }
                                      >
                                        <img
                                          src={CheckImg}
                                          alt=""
                                          height="20"
                                        />
                                      </span>
                                    ) : (
                                      <span
                                        className="not-selected"
                                        onClick={() =>
                                          this.state.permissions &&
                                          this.state.permissions.editable &&
                                          this.updateCompensatorList(
                                            2,
                                            department.departmentid,
                                            true,
                                          )
                                        }
                                      />
                                    )}
                                  </div>
                                );
                              },
                            )}
                        </div>
                      </div>
                    </Grid>
                    <Grid
                      item
                      md={4}
                      sm={12}
                      className="compensator-assignment-list"
                      style={{ overflowY: "auto", height: "calc(100% - 10px)" }}
                    >
                      <div style={{ padding: "0 16px" }}>
                        <div style={{ height: 20 }}>
                          <div className="text-center sub-heading">
                            Select locations
                          </div>
                        </div>
                        <div className="compensator-checkbox">
                          <div className="margin-bottom-16 margin-top-16 cursurpointer">
                            <span className="all-select">Select all</span>
                            {this.state.allloc ? (
                              <span
                                className="floatright"
                                onClick={() =>
                                  this.state.permissions &&
                                  this.state.permissions.editable &&
                                  this.selectAll(3, false)
                                }
                              >
                                <img src={CheckImg} alt="" height="20" />
                              </span>
                            ) : (
                              <span
                                className="not-selected"
                                onClick={() => this.selectAll(3, true)}
                              ></span>
                            )}
                            {/* {this.state.allloc ? (
                             <DynamicForm
                             fields={checkboxinputconverter({
                               value: true,
                               placeholder: "",
                               label: "",
                               // disabled: participant[0].isSelected == false ? true : false,
                             })}
                             onChange={() => this.selectAll(3, false)
                             }
                          /> ) : (
                          <DynamicForm
                          fields={checkboxinputconverter({
                            value: false,
                            placeholder: "",
                            label: "",
                            // disabled: participant[0].isSelected == false ? true : false,
                          })}
                          onChange={() => this.selectAll(3, true)
                          }
                        />
                          )} */}
                          </div>
                          {this.state.LocationList &&
                            this.state.LocationList.map(
                              (location, locindex) => {
                                const locationAccessObject =
                                  get(
                                    this.state,
                                    "selectedCompensator.access",
                                    "",
                                  ) &&
                                  get(
                                    this.state,
                                    "selectedCompensator.access",
                                    [],
                                  ).find((x) => x.applicablefortypeid == 3);
                                let isChecked = false;
                                if (
                                  locationAccessObject &&
                                  locationAccessObject.applicableforids &&
                                  locationAccessObject.applicableforids.length >
                                    0 &&
                                  locationAccessObject.applicableforids.findIndex(
                                    (y) => y == location.displayvalue,
                                  ) != -1
                                ) {
                                  isChecked = true;
                                } else {
                                  isChecked = false;
                                }
                                return (
                                  <div
                                    key={locindex}
                                    className="margin-bottom-16 margin-top-16 cursurpointer"
                                  >
                                    <span className="select-label ellipsis">
                                      {location.displayname}
                                    </span>
                                    {isChecked ? (
                                      <span
                                        className="floatright"
                                        onClick={() =>
                                          this.state.permissions &&
                                          this.state.permissions.editable &&
                                          this.updateCompensatorList(
                                            3,
                                            location.displayvalue,
                                            false,
                                          )
                                        }
                                      >
                                        <img
                                          src={CheckImg}
                                          alt=""
                                          height="20"
                                        />
                                      </span>
                                    ) : (
                                      <span
                                        className="not-selected"
                                        onClick={() =>
                                          this.state.permissions &&
                                          this.state.permissions.editable &&
                                          this.updateCompensatorList(
                                            3,
                                            location.displayvalue,
                                            true,
                                          )
                                        }
                                      />
                                    )}
                                  </div>
                                );
                              },
                            )}
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12} md={3} sm={3} />
                <Grid item xs={12} md={9} sm={3}>
                  <div className="margin-top-16">
                    <div className="margin-right-10 floatleft">
                      <img src={warning} />
                    </div>
                    <div className="warning-msg">
                      Some of the employees might not have a compensator. Please
                      check the settings of all compensator or assign
                      compensation access of "all business units/departments or
                      locations" to atleast one compensator.
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            {this.state.permissions && this.state.permissions.editable && (
              <Grid item xs={12} md={12} sm={12}>
                <Button
                  color="primary"
                  variant="contained"
                  style={{ width: 140 }}
                  onClick={this.onSave}
                >
                  Save
                </Button>
              </Grid>
            )}
          </Grid>
        )}
      </div>
    );
  }
}

Compensator.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  SubscriptionData: state.SubscriptionInfo.SubscriptionData,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles()(withSnackbar(Compensator)));
